/** 自定义错误类型，告警标题 */
export enum ERROR_TYPE_ENUM {
  JS = '代码异常',
  RESOURCE = '资源加载异常',
  RENDER = '渲染异常',
  INTERACTION = '交互异常',
  HTTP = '请求异常',
  WS = 'Websocket异常',
}
